import { Injectable, NgZone } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class GoogleTranslateService {
    constructor(private ngZone: NgZone) {
    }

    loadScript(): Promise<void> {
        return new Promise((resolve, reject) => {
            const script = document.createElement('script');
            script.src = '//translate.google.com/translate_a/element.js?cb=loadGoogleTranslate';
            script.async = true;
            script.onload = () => resolve();
            script.onerror = error => reject(error);
            document.body.appendChild(script);
        });
    }
}
